import { render, staticRenderFns } from "./UIDialogDeleteRecent.vue?vue&type=template&id=a04ab1ca&scoped=true&"
import script from "./UIDialogDeleteRecent.vue?vue&type=script&lang=js&"
export * from "./UIDialogDeleteRecent.vue?vue&type=script&lang=js&"
import style0 from "./UIDialogDeleteRecent.vue?vue&type=style&index=0&id=a04ab1ca&prod&scoped=true&lang=css&"
import style1 from "./UIDialogDeleteRecent.vue?vue&type=style&index=1&id=a04ab1ca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a04ab1ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VDialog})
